var SupportBasePresentation, SupportGetawaysMarketRatePresenterPresentation, SupportGetawaysMarketRateStatusAndNotesPresentation, SupportPresenterUtilPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportGetawaysMarketRateStatusAndNotesPresentation = require('./getaways_market_rate_messages');

SupportGetawaysMarketRatePresenterPresentation = (function(superClass) {
  extend(SupportGetawaysMarketRatePresenterPresentation, superClass);

  function SupportGetawaysMarketRatePresenterPresentation() {
    return SupportGetawaysMarketRatePresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGetawaysMarketRatePresenterPresentation.prototype.getLookupObject = function() {
    return SupportGetawaysMarketRateStatusAndNotesPresentation;
  };

  SupportGetawaysMarketRatePresenterPresentation.prototype.getLookupKeySequence = function() {
    var keys;
    keys = [];
    if (this.order != null) {
      keys.push(SupportPresenterUtilPresentation.prototype.getStatusKey(this.order));
    }
    return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
  };

  return SupportGetawaysMarketRatePresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGetawaysMarketRatePresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c19tYXJrZXRfcmF0ZV9wcmVzZW50ZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c19tYXJrZXRfcmF0ZV9wcmVzZW50ZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsOEpBQUE7RUFBQTs7O0FBQUEsdUJBQUEsR0FBMEIsT0FBQSxDQUFRLFFBQVI7O0FBQzFCLGdDQUFBLEdBQW1DLE9BQUEsQ0FBUSxrQkFBUjs7QUFDbkMsbURBQUEsR0FBc0QsT0FBQSxDQUFRLGlDQUFSOztBQUVoRDs7Ozs7OzsyREFDTCxlQUFBLEdBQWlCLFNBQUE7V0FDaEI7RUFEZ0I7OzJEQUdqQixvQkFBQSxHQUFzQixTQUFBO0FBQ3JCLFFBQUE7SUFBQSxJQUFBLEdBQU87SUFFUCxJQUFHLGtCQUFIO01BQ0MsSUFBSSxDQUFDLElBQUwsQ0FBVSxnQ0FBZ0MsQ0FBQSxTQUFFLENBQUEsWUFBbEMsQ0FBK0MsSUFBQyxDQUFBLEtBQWhELENBQVYsRUFERDs7V0FFQSxnQ0FBZ0MsQ0FBQSxTQUFFLENBQUEscUJBQWxDLENBQXdELElBQXhEO0VBTHFCOzs7O0dBSnNDOztBQVc3RCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
